import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { catalogPath, type ProductType } from "@/lib/url-slugs";
import type { NavMenuGroup } from "@/hooks/use-nav-menu-data";

interface MegaMenuProps {
  groupKey: string;
  data: NavMenuGroup | undefined;
  onClose: () => void;
}

const TYPE_LABELS: Record<string, Record<string, string>> = {
  rackets: { lv: "Raketes", en: "Rackets" },
  apparel: { lv: "Apģērbs", en: "Apparel" },
  shoes: { lv: "Apavi", en: "Shoes" },
  bags: { lv: "Somas", en: "Bags" },
  balls: { lv: "Bumbas", en: "Balls" },
  accessories: { lv: "Aksesuāri", en: "Accessories" },
};

const MegaMenu = ({ groupKey, data, onClose }: MegaMenuProps) => {
  const { lang, getCategoryName } = useLanguage();

  const categories = data?.categories ?? [];
  const brands = data?.brands ?? [];
  const hasCategories = categories.length > 0;
  const hasBrands = brands.length > 0;

  if (!hasBrands) return null;

  const productType = (["rackets","apparel","shoes","bags","balls","accessories"].includes(groupKey)
    ? (groupKey as ProductType)
    : null);
  const allLink = productType ? catalogPath(lang, productType) : `/${lang}`;
  const allLabel = TYPE_LABELS[groupKey]?.[lang] ?? groupKey;

  return (
    <div className="p-3 min-w-[180px]">
      <ul className="space-y-0.5">
        {brands.map((brand) => (
          <li key={brand}>
            <Link
              to={productType ? catalogPath(lang, productType, brand) : `/${lang}`}
              onClick={onClose}
              className="block px-3 py-1.5 text-sm text-foreground/80 hover:text-primary hover:bg-muted rounded transition-colors"
            >

              {brand}
            </Link>
          </li>
        ))}
        <li className="border-t border-border mt-1 pt-1">
          <Link
            to={allLink}
            onClick={onClose}
            className="block px-3 py-1.5 text-sm font-semibold text-primary hover:text-primary/80 hover:bg-muted rounded transition-colors"
          >
            {lang === "lv" ? `Visi: ${allLabel}` : `All ${allLabel}`}
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default MegaMenu;
